import React from 'react';

import ConfirmDialog from 'components/confirm-dialog';
import { useAuthContext } from 'state/auth';
import { t } from 'state/intl/translations';

interface IExistingModalDialogProps {
  showDialog: boolean;
  dismiss: () => void;
}

const ExistingEmailDialog: React.FC<React.PropsWithChildren<IExistingModalDialogProps>> = ({
  showDialog,
  dismiss,
}) => {
  const { openSignInModal } = useAuthContext();

  return (
    <ConfirmDialog
      showDialog={showDialog}
      body={t('logInWithExistingEmail')}
      confirmLabel={t('logIn')}
      heading={t('welcomeBack')}
      onCancel={dismiss}
      onConfirm={() => {
        dismiss();
        openSignInModal();
      }}
      onDismiss={dismiss}
      modalAppearanceEventMessage="Email exists sign in prompt modal"
    />
  );
};

export default ExistingEmailDialog;
